/**
 * 시안 여섯의 <b>열쇠만</b> — 시안 자체는 들고 오지 않는다.
 *
 * <h2>왜 갈라 뒀나</h2>
 * 투표 창({@code components/PollModal})은 「이 선택지를 눌러 볼 수 있는가」 를 <b>그리기 전에</b>
 * 알아야 한다. 그 물음 하나 때문에 {@code HomepagePreview} 를 곧바로 불러 오면, 홈에 들어오는
 * 모든 사람이 시안 다섯 벌과 WebGL 조각까지 함께 내려받는다 — 열어 보지도 않고서.
 *
 * <p>여기에는 문자열 다섯뿐이라 어디서 불러도 값이 없다시피 하고, 실제 화면은 「눌러보기」 를
 * 누른 사람에게만 {@code lazy} 로 온다.
 *
 * <p>값은 {@code board_poll_options.preview_key} 에 그대로 들어 있다(V350).
 *
 * <p><code>corporate</code>(시안 F · 2026-09-30)는 아직 투표 선택지에 <b>없다</b>. 선택지를
 * 더하는 일은 표가 들어오기 전에만 할 수 있고(V352 머리말), 그 결정은 사람이 한다.
 */
export const HOMEPAGE_PREVIEW_KEYS = ['classic', 'editorial', 'tech', 'museum', 'archive', 'corporate'] as const;

export type HomepagePreviewKey = (typeof HOMEPAGE_PREVIEW_KEYS)[number];

/**
 * 우리가 띄울 수 있는 시안인가.
 *
 * <p>모르는 열쇠에는 「눌러보기」 를 세우지 않는다 — 눌러도 아무것도 안 열리는 단추를 두느니
 * 없는 편이 낫다. 자료가 앞서고 화면이 따라오는 자리라, 이런 값이 실제로 생길 수 있다.
 */
export function isHomepagePreviewKey(key: string | null | undefined): key is HomepagePreviewKey {
  return HOMEPAGE_PREVIEW_KEYS.includes(key as HomepagePreviewKey);
}
